import type { ReactNode, SVGProps } from "react";

export function NewBatchPaymentIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="17"
			viewBox="0 0 15 17"
			width="15"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.80029 0.600098V3.88215C7.80029 4.09976 7.88458 4.30846 8.03461 4.46234C8.18464 4.61622 8.38812 4.70266 8.60029 4.70266H11.8003"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M6.18311 6.31445V11.6478"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M4.1001 8.53668L6.18343 6.31445L8.26676 8.53668"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M6.2001 15.3693H2.2001C1.77575 15.3693 1.36878 15.1964 1.06873 14.8887C0.768669 14.5809 0.600098 14.1635 0.600098 13.7283V2.24112C0.600098 1.8059 0.768669 1.38849 1.06873 1.08074C1.36878 0.772991 1.77575 0.600098 2.2001 0.600098H7.8001L11.8001 4.70266V7.57446"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M8.7666 13.4573H14.0166"
				stroke="#131316"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M11.3916 16.0286V10.8857"
				stroke="#131316"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
